import Vue from 'vue'
import App from './App.vue'
import './registerServiceWorker'
import router from './router'
import store from './store'
import vuetify from './plugins/vuetify';
import './assets/main.scss';
import Toasted from 'vue-toasted';
import VueAnalytics from 'vue-analytics'

Vue.config.productionTip = false
Vue.use(Toasted)
Vue.use(VueAnalytics, {
  id: 'UA-167509673-1',
  router,
  autoTracking: {
    pageviewOnLoad: false
  }
})

new Vue({
  router,
  store,
  vuetify,
  render: h => h(App)
}).$mount('#app')
